export default __webpack_public_path__ + "static/media/email-verified.25b51211.svg";